import { render, staticRenderFns } from "./SuspectedChart.vue?vue&type=template&id=791231a2&scoped=true&"
import script from "./SuspectedChart.vue?vue&type=script&lang=ts&"
export * from "./SuspectedChart.vue?vue&type=script&lang=ts&"
import style0 from "./SuspectedChart.vue?vue&type=style&index=0&id=791231a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791231a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791231a2')) {
      api.createRecord('791231a2', component.options)
    } else {
      api.reload('791231a2', component.options)
    }
    module.hot.accept("./SuspectedChart.vue?vue&type=template&id=791231a2&scoped=true&", function () {
      api.rerender('791231a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/SuspectedChart.vue"
export default component.exports